export interface Volume {
  number: number
  title: string
  classes: string
  description: string
  cover: string
}

export const volumes: Volume[] = [
  {
    number: 1,
    title: 'Foundations & Gentle Yoga™',
    classes: '20 Ready-to-Teach Classes',
    description: 'Accessible, well-paced classes for beginners, gentle groups and mixed-level rooms.',
    cover: 'https://cdn.magicpatterns.com/patterns/generated-images/985d7f61-1e97-421c-8ce9-a37c72bf86be.jpg',
  },
  {
    number: 2,
    title: 'Hatha & Balanced Flow™',
    classes: '20 Ready-to-Teach Classes',
    description: 'Classic structure with steady pacing — dependable classes for your weekly schedule.',
    cover: 'https://cdn.magicpatterns.com/patterns/generated-images/1f0d507b-fb43-4f11-8344-7b536a56a68d.jpg',
  },
  {
    number: 3,
    title: 'Slow Flow & Mindful Movement™',
    classes: '20 Ready-to-Teach Classes',
    description: 'Breath-led sequences with smooth transitions for calm, focused practice.',
    cover: 'https://cdn.magicpatterns.com/patterns/generated-images/84bc356d-625c-4303-8fdc-76c058df3721.jpg',
  },
  {
    number: 4,
    title: 'Mobility & Functional Yoga™',
    classes: '20 Ready-to-Teach Classes',
    description: 'Joint-friendly classes built around range of motion, stability and strength.',
    cover: 'https://cdn.magicpatterns.com/patterns/generated-images/dbdbaf31-4aca-4441-a6e4-04ce69ca971b.jpg',
  },
  {
    number: 5,
    title: 'Restorative, Yin & Deep Release™',
    classes: '20 Ready-to-Teach Classes',
    description: 'Long holds, prop set-ups and quiet classes for evenings and recovery.',
    cover: 'https://cdn.magicpatterns.com/patterns/generated-images/bcde2403-f1ee-4bf0-a4f2-6f5b7a7f2077.jpg',
  },
  {
    number: 6,
    title: 'Specialty Yoga Class Vault™',
    classes: '20 Ready-to-Teach Classes',
    description: 'Themed and situational classes for workshops, private clients and special sessions.',
    cover: 'https://cdn.magicpatterns.com/patterns/generated-images/b2875aea-dff3-4bfd-b328-0e88fd69de10.jpg',
  },
]
